import * as React from 'react';

import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';

export type CheckboxProps = {
	icon?:       React.ReactNode;
	inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
	rootRef?:    React.Ref<HTMLLabelElement>;
} & ChakraCheckbox.RootProps;

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	(props, ref) => {
		const {
			icon, children, inputProps, rootRef, ...rest
		} = props;

		return (
			/* @ts-ignore */
			<ChakraCheckbox.Root ref={rootRef} {...rest}>
				<ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
				<ChakraCheckbox.Control>
					{icon || <ChakraCheckbox.Indicator />}
				</ChakraCheckbox.Control>
				{children !== null
				&& <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
			</ChakraCheckbox.Root>
		);
	},
);

Checkbox.displayName = 'Checkbox';